module.exports = __webpack_public_path__ + "img/1920_ocr_demo.92a0fed0.png";